import { useEffect, useState } from "react";
import { config } from "../config/app";
import { useCustomNavigate } from "../utils/helper";

const AppPopup = (props: any) => {
  const [popup, setPopup] = useState<any>({});
  const navigate = useCustomNavigate();
  useEffect(() => {
    if (props?.setting?.data?.configs?.popup) {
      const _popup = props.setting.data.configs.popup;
      const closePopupIds = JSON.parse(
        localStorage.getItem(config.appPackage + "_popup_hidden") || "[]"
      );
      if (!closePopupIds.includes(_popup.id)) setPopup(_popup);
    }
  }, [props]);

  const handleInAppLink = () => {
    navigate(popup.action_link);
  };

  const renderInAppContent = () => {
    return <img src={popup.image} onClick={handleInAppLink} alt={""} />;
  };

  const renderOutAppContent = () => {
    return <img src={popup.image} alt={""} />;
  };

  const renderContent = () => {
    switch (popup.action_type) {
      case "INAPP":
        return renderInAppContent();
      case "OUTAPP":
        return renderOutAppContent();
    }
  };

  return popup?.show ? (
    <div className={"app-popup"}>
      <div className="app-popup-content">
        <div className="app-popup-btn-close">X</div>
        <div className="app-popup-image">{renderContent()}</div>
      </div>
    </div>
  ) : (
    <></>
  );
};
export default AppPopup;
